import React from 'react';
import {
  Grid, Paper, Typography, Button
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { useUserState } from '../../context/UserContext';
// styles
import useStyles from './styles';

// logo
import logo from '../../images/logo-escuro.png';
import logo2 from '../../images/logo-branco.png';

export default function Error() {
  const { isAuthenticated } = useUserState();
  const classes = useStyles({ isAuthenticated });

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotype}>
        {isAuthenticated ? (
          <img className={classes.logotypeIcon} src={logo} alt="logo" />
        ) : (
          <img className={classes.logotypeIcon} src={logo2} alt="logo" />
        )}
      </div>
      <Paper classes={{ root: classes.paperRoot }}>
        <Typography
          variant="h1"
          color="primary"
          className={classnames(classes.textRow, classes.errorCode)}
        >
          404
        </Typography>
        <Typography variant="h5" color="primary" className={classes.textRow}>
          Oops. Página não encontrada
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to={isAuthenticated ? '/app/dashboard' : '/'}
          size="large"
          className={classes.backButton}
        >
          Voltar para Home
        </Button>
      </Paper>
    </Grid>
  );
}
